import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export default function useMeta() {
  const [meta, setMeta] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/meta/options").then(({ data }) => { cache = data; setMeta(data); }).catch(() => {});
  }, []);
  return meta || { pipeline_stages: [], role_types: [], hiring_types: [], org_types: [], availability: [] };
}
